import {
  CLIENT_CENTER_LIST_PATH,
  LEGACY_CUSTOMERS_LIST_PATH,
} from '../../constants';

export const isCustomerRouteHiddenByActurisFlag = (
  path: string,
  isActurisEnabled: boolean,
): boolean => {
  if (path.startsWith(CLIENT_CENTER_LIST_PATH)) {
    return !isActurisEnabled;
  }

  if (path === LEGACY_CUSTOMERS_LIST_PATH) {
    return isActurisEnabled;
  }

  return false;
};
